export default __webpack_public_path__ + "static/media/italic.baa21181.svg";